

const NotificationType = {
  Success: "success",
  Notification: "notification",
  Warning: "warning",
  Error: "error"
};

export const EnumUtility = {

  StateIDKey: {
    Kansas: { ID: 4, Name: "Kansas" },
    Mississippi: { ID: 30, Name: "Mississippi" },
    Tennessee: { ID: 70, Name: "Tennessee" },
    Louisiana: { ID: 120, Name: "Louisiana" },
    Wyoming: { ID: 140, Name: "Wyoming" },
    Virginia: { ID: 160, Name: "Virginia" },
    Colorado: { ID: 180, Name: "Colorado" },
    NorthCarolina: { ID: 200, Name: "North Carolina" },
    Nebraska: { ID: 230, Name: "Nebraska" },
    ZZState: { ID: 1000, Name: "ZZState" },
  },

  // StateMessageKey: {
  //   Wyoming: { ID: 140, Name: "Wyoming", CaseRegexMessage: "Case number must be all numeric, no more than 9 digits, no leading zeroes." },
  //   Colorado: { ID: 180, Name: "Colorado", CaseRegexMessage: "Case number must be 11 digits followed by 1 letter." },
  //   ZZState: { ID: 1000, Name: "ZZState", CaseRegexMessage: "Case number must be all numeric, no more than 10 digits, no leading zeroes." },
  // },

  ApiRequestorKey: {
    ClientAPI: { ID: 100, Name: "ClientAPI" },
    SsoAPI: { ID: 120, Name: "SsoAPI" },
    MasterAPI: { ID: 140, Name: "MasterAPI" },
    DocumentAPI: { ID: 150, Name: "DocumentAPI" },
    MainframeScrapeAPI: { ID: 500, Name: "MainframeScrapeAPI" },
  }, 

  MainframePushBlockID: {
    MississippiCaseSearch: { ID: 72, Name: "MississippiCaseSearch", Description: "Block ID for Case Search in Mississippi" },
    MississippiNarrativeSave: { ID: 73, Name: "SsoAPI", Description: "Block ID for Narrative push in Mississippi" },
    KansasCaseSearch: { ID: 67, Name: "ClientAPI", Description: "Block ID for Case Search in Kansas" },
    KansasNarrativeSave: { ID: 47, Name: "SsoAPI", Description: "Block ID for Narrative push in Kansas" },
  },   

  NavigationMenuType: {
    SiteSelection: { ID: 100, Name: "SiteSelection", NavigateTo: "/siteselect" },
    LogOut: { ID: 110, Name: "LogOut", NavigateTo: "/siteselect" },
    NewDocumentIndex: { ID: 200, Name: "NewDocumentIndex", NavigateTo: "./newdocument" },
    DocumentSearch: { ID: 300, Name: "DocumentSearch", NavigateTo: "./documentsearch" },
    CaseView: { ID: 400, Name: "CaseView", NavigateTo: "./caseView" },
    MyYTrac: { ID: 500, Name: "MyYTrac", NavigateTo: "./myytrac" },
    NewWorkItem: { ID: 600, Name: "NewWorkItem", NavigateTo: "./newWorkitem" },
    NextWorkItem: { ID: 700, Name: "NextWorkItem", NavigateTo: "./nextWorkitem" },
    QueueWorkflow: { ID: 800, Name: "QueueWorkflow", NavigateTo: "./queueWorkflow" },
    Completed: { ID: 900, Name: "Completed", NavigateTo: "./completed" },
    NewWalkIn: { ID: 1000, Name: "NewWalkIn", NavigateTo: "./newwalkin" },
  },

  CaseType: {
    Case: "with_case",
    NoCase: "no_case"
  },

  CaseStatusType: {
    ActiveCase: { ID: 4, Name: "Ative" },
    ClosedCase: { ID: 5, Name: "Closed" },
    ArrearsCase: { ID: 8, Name: "Arrears" },
    NotAvailable: { ID: 0, Name: "NotAvailable" },
    Running: { ID: 6, Name: "Running" },
  },

  CaseSearchResultCode: {
    CaseFound: { ID: 100, Name: "CaseFound" },
    CaseNotFound: { ID: 200, Name: "CaseNotFound" },
    NetworkError: { ID: 300, Name: "NetworkError" },
    OtherError: { ID: 400, Name: "OtherError" },
    MFSessionDisconnectError: { ID: 600, Name: "MainframeSessionDisconnected" },
    ScraperDisconnectedError: { ID: 700, Name: "ScraperDisconnected" },
    ScraperSessionError: { ID: 800, Name: "mainframesessionerror" },
    ConnectionTestSuccess: { ID: 900, Name: "ConnectionTestSuccess" },
    Enter_A_Function_Error: { ID: 1000, Name: "Enter_A_Function_Error" }
  },

  CaseSearchErrorMessage: {
    MainframeNotRegistered: { ID: 100, Name: "MainframeNotRegistered",  Message: "Mainframe Interaction is not registered" },
    Error2: { ID: 200, Name: "MainframeNotRegistered",  Message: "Mainframe Interaction is not registered" },
    Error3: { ID: 300, Name: "MainframeNotRegistered",  Message: "Mainframe Interaction is not registered" },
    Error4: { ID: 400, Name: "MainframeNotRegistered",  Message: "Mainframe Interaction is not registered" },
    Error5: { ID: 500, Name: "MainframeNotRegistered",  Message: "Mainframe Interaction is not registered" },
  },

  DocumentSearchPageProperty: {
    DocumentSearch: { ID: 100, mainTitle: "Document Search", formTitle: "Search", viewOnly: true },
    ReIndexDocument: { ID: 200, mainTitle: "Document", formTitle: "Re-Index", viewOnly: false },
  },

  DocumentViewerOperationType: {
    SplitButton: { ID: 100, Name: "SplitButton" },
    DeleteButton: { ID: 200, Name: "DeleteButton" },
  },
  
  SiteSettingsDetail: {
    CaseNumberRegex: { ID: 100, Name: "CaseNumberRegex", SettingsDetailID: 129, },
    CaseNumberInsertAllow: { ID: 105, Name: "CaseNumberInsertAllow", SettingsDetailID: 615, },
    DocumentPath: { ID: 200, Name: "DocumentPath", SettingsDetailID: 180, },
    NotesCharsLimit: { ID: 300, Name: "NotesCharsLimit", SettingsDetailID: 85 , },
    NarrativeCharsLimit: { ID: 400, Name: "NarrativeCharsLimit", SettingsDetailID: 68, },
    NarrativeCopyToClipboardIndex: { ID: 500, Name: "NarrativeCopyToClipboardIndex", SettingsDetailID: 602, },
    NarrativeCopyToClipboardManageKeywords: { ID: 501, Name: "NarrativeCopyToClipboardManageKeywords", SettingsDetailID: 603, },
    DocumentSearchResultsCapacity: { ID: 601, Name: "DocumentSearchResultsCapacity", SettingsDetailID: 428, },
    DaysToNextFollowup: { ID: 701, Name: "DaysToNextFollowup", SettingsDetailID: 523, },
    DocViewerLicenseKey: { ID: 2000, Name: "DocViewerLicenseKey", SettingsDetailID: 616, },
    DocViewerPrintQuality: { ID: 2010, Name: "DocViewerPrintQuality", SettingsDetailID: 653, },
    ApiWriteNarrative: { ID: 2015, Name: "ApiWriteNarrative", SettingsDetailID: 669, },
  },

  NarrativeCopyToClipboard: {
    Allow: "1",
    DoNotAllow: "0"
  },
  
  DateType: {
    StartDate: "start_date",
    EndDate: "end_date"
  },

  NotificationType: {
    Success: "success",
    Notification: "notification",
    Warning: "warning",
    Error: "error"
  },

  BatchDocumentProcess: {
    NoBatchAvailableForIndex: { ID: 10, Name: "NoBatchAvailableForIndex", NotificationType: NotificationType.Notification, Title: "Notification", Message: "There are currently no batches available for indexing" },
    HasDocumentForIndex: { ID: 100, Name: "HasDocumentForIndex", NotificationType: NotificationType.Success, Title: "Success", Message: "Document Available" },
    DocumentNotAvailable: { ID: 110, Name: "DocumentNotAvailable", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Document Not Available" },
    NoPendingDocuments: { ID: 120, Name: "NoPendingDocuments", NotificationType: NotificationType.Success, Title: "Document Indexing Complete", Message: "You are at the end of this batch. Please select a new batch." },
    DocumentSavedSuccess: { ID: 200, Name: "DocumentSavedSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "This document has been successfully saved!" },
    DocumentIndexSplitSuccess: { ID: 300, Name: "DocumentIndexSplitSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "A new document for the split page(s) has been created and added after the current document" },
    DocumentIndexSplitAllSuccess: { ID: 301, Name: "DocumentIndexSplitAllSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "A new document has been created for each page and added after the current document" },
    DocumentIndexDeleteSuccess: { ID: 305, Name: "DocumentIndexDeleteSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "The selected document page(s) have been deleted" },
    DocumentSearchSplitSuccess: { ID: 310, Name: "DocumentSearchSplitSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "A new batch for the split page(s) has been created" },
    DocumentSearchSplitAllSuccess: { ID: 311, Name: "DocumentSearchSplitAllSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "A new batch has been created for each page" },
    DocumentSearchDeleteSuccess: { ID: 320, Name: "DocumentSearchDeleteSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "The selected document page(s) have been deleted" },
    DocumentSplitNotAvailable: { ID: 400, Name: "DocumentSplitNotAvailable", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Please select some pages" },
    DocumentSplitAllNotAvailable: { ID: 405, Name: "DocumentSplitAllNotAvailable", NotificationType: NotificationType.Warning, Title: "Warning", Message: "This document only has one page and cannot be split further" },
    DocumentRotateSuccess: { ID: 500, Name: "DocumentRotateSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "The page(s) in the document has been successfully rotated!" },
    ErrorLoadingDocument: { ID: 999, Name: "ErrorLoadingDocument", NotificationType: NotificationType.Error, Title: "Error", Message: "Error Loading Document" },
    BatchLocked: { ID: 1000, Name: "BatchLocked", NotificationType: NotificationType.Error, Title: "Error", Message: "This batch is currently being worked by <User First Name Last Name>.  \nPlease select a different batch" },
    CaseNumberAddedAgain: { ID: 2000, Name: "CaseNumberAddedAgain", NotificationType: NotificationType.Error, Title: "Error", Message: "You've already applied this case number to this document. Please verify the case number and try again." },
  },

  WorkflowProcess: {
    NewWorkflowForCaseSavedSuccess: { ID: 10, Name: "NewWorkflowForCaseSavedSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "{0} has been successfully created for Case ID {1}." },
    NewWorkflowWithNoCaseSavedSuccess: { ID: 15, Name: "NewWorkflowWithNoCaseSavedSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "{0} has been successfully created for No Case." },
    NextWorkflowSavedSuccess: { ID: 20, Name: "NextWorkflowSavedSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "This work item has been successfully saved! Keep up the good work!" },
    NewWalkinWorkflowSavedSuccess: { ID: 25, Name: "NewWalkinWorkflowSavedSuccess", NotificationType: NotificationType.Success, Title: "Success", Message: "This Walk-In has been successfully saved!"},
    NoMoreCaseWorkflows: { ID: 30, Name: "NoMoreCaseWorkflows", NotificationType: NotificationType.Notification, Title: "Notification", Message: "No Active Workflows on this Case" },
  },

  NotificationAlerts: {
    UserFound: { ID: 100, Name: "UserFound", NotificationType: NotificationType.Success, Title: "Success", Message: "Please select a State from the list below" },
    UserNotFound: { ID: 120, Name: "UserNotFound", NotificationType: NotificationType.Warning, Title: "Warning", Message: "User Not Available. Please enter Valid Email Address" },
    ManageKeywordsSuccess: { ID: 130, Name: "UserNotFound", NotificationType: NotificationType.Success, Title: "Success", Message: "Manage Keywords updated successfully" },
    ManageKeywordsFailure: { ID: 140, Name: "ManageKeywordsFailure", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Manage Keywords update failed." },
    DocumentNotFound: { ID: 150, Name: "DocumentNotFound", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Document not found in the location provided." },
    CaseClosed: { ID: 300, Name: "CaseClosed", NotificationType: NotificationType.Notification, Title: "Closed Case", Message: "The Case ID {0} is closed in the state system." },
    CaseNumberNotFound: { ID: 320, Name: "CaseNumberNotFound", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Could not locate case in the system. Please verify the case number and try again." },
    CaseNumberFormatInvalid: { ID: 330, Name: "CaseNumberFormatInvalid", NotificationType: NotificationType.Warning, Title: "Warning", Message: "The Case ID {0} entered is invalid.  Please enter a valid case number. \n{1}" },
    DocumentSearchExcessiveResults: { ID: 500, Name: "DocumentSearchExcessiveResults", NotificationType: NotificationType.Notification, Title: "Excessive Search Results", Message: "The search criteria returned {0} records. The Search Results grid displays {1} records. Please revise the search criteria if necessary." },
    MainframeSessionDisconnected: { ID: 600, Name: "MainframeSessionDisconnected", NotificationType: NotificationType.Warning, Title: "Warning", Message: "Your session with the mainframe has been disconnected. Please login to KAECSES again." },
    FVIAndConfidentialCase: { ID: 700, Name: "FVIAndConfidentialCase", NotificationType: NotificationType.Warning, Title: "Warning", Message: "This case is marked as FVI and Confidential. Please handle accordingly." },
    NoMoreTasksDueToday: { ID: 800, Name: "NoMoreTasksDueToday", NotificationType: NotificationType.Warning, Title: "Warning", Message: "No more tasks are due today. Please see your Supervisor for direction." },
  },

  // Helper function to get CaseNumberNotFound error based on user's state
  getCaseNumberNotFoundError: function(userStateID) {
    // Only show the error message for MS (30), KS (4), and WY (140)
    const allowedStates = [30, 4, 140]; // Mississippi, Kansas, Wyoming
    if (allowedStates.includes(userStateID)) {
      return this.NotificationAlerts.CaseNumberNotFound;
    }
    // Return null for other states - no error message should be shown
    return null;
  },

  // Helper function to check if case number should be preserved based on error message
  shouldPreserveCaseNumber: function(errorMessage) {
    if (!errorMessage) return false;
    
    // Extract message text from various error object formats
    let messageText = '';
    if (typeof errorMessage === 'string') {
      messageText = errorMessage;
    } else if (errorMessage.Message) {
      messageText = errorMessage.Message;
    } else if (errorMessage.message) {
      messageText = errorMessage.message;
    }
    
    // Check if message contains "Please verify the case number and try again"
    return messageText.includes('Please verify the case number and try again');
  },

  ConfirmDialogType: {
    NewDocumentCancel: { ID: 100, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Any unsaved changes will be lost.  Are you sure you want to proceed?" },
    SkipDocument: { ID: 110, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Any unsaved changes will be lost.  Are you sure you want to skip the document?" },
    CloseDocumentEditor: { ID: 120, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Any unsaved changes will be lost. Are you sure you want to proceed?" },
    CaseNumberFound: { ID: 310, NotificationType: NotificationType.Success, Title: "Success", Message: "Case Number Found" },
    CaseNumberNotFound: { ID: 320, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Case Number Not Found" },
    RemoveDocumentFromCase: { ID: 400, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Are you sure you want to remove the document from the case?" },
    SplitDocument: { ID: 500, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Are you sure you want to split the document?" },
    SplitAllDocument: { ID: 505, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Are you sure you want to split every page into its own separate document?" },
    DeleteDocumentPages: { ID: 550, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Are you sure you want to delete these pages?" },
    RemoveActionFromWorkflow: { ID: 5000, NotificationType: NotificationType.Warning, Title: "Warning", Message: "Are you sure you want to remove the list of action from the workflow?" },
    SubmitCaseWithNoNarrative: { ID: 4023, NotificationType: NotificationType.Warning, Title: "Confirm submit with no narrative", Message: "You are submitting the case with no Narrative attached. Are you sure you want to proceed?" },
    DuplicateActionAddToList : { ID: 999, NotificationType: NotificationType.Warning, Title: "Warning", Message: "This action has already been added: {0}. Would you like to add it again?" },
    NewWalkInCancel: {ID: 1000, NotificationType:  NotificationType.Warning, Title: "Warning", Message: "Any unsaved changes will be lost.  Are you sure you want to proceed?"}
  },

  SiteSelectionAlerts: {
    UserFound: { ID: 100, Name: "UserFound", NotificationType: NotificationType.Success, Title: "Success", Message: "Please select a State from the list below" },
    UserNotFound: { ID: 120, Name: "UserNotFound", NotificationType: NotificationType.Warning, Title: "Warning", Message: "User Not Available. Please enter Valid Email Address" },
    SignInToContinue: { ID: 140, Name: "SignInToContinue", NotificationType: NotificationType.Notification, Title: "Notification", Message: "Please sign-in to continue" },
    StateAndSiteAccess: { ID: 200, Name: "StateAndSiteAccess", NotificationType: NotificationType.Notification, Title: "Notification", Message: "Please contact your Administrator for State and Site access" },
  },



  /**
     * const GetCaseDocumentListMapping 
     * Assigns values from an array of objects to the model
     * Array value from Client API: CaseDocument/GetCaseDocumentList
     * Model: CaseDocumentsModel from ModelLibrary
     */
  CaseDocumentListMapping: {
    createdTS: "scanDate",              // Map "createdTS" in the array to "scanDate" in the model. Similarly for the fields below
    indexTS: "indexDate",
    documentGroupTypeName: "documentGroup",
    documentTypeName: "documentType",
    documentSource: "documentSource",
    batchDocumentID: "batchDocumentID",
    documentUNCPath: "documentUNCPath"
  },


};

/* 
const EnumUtility = {
  ApiRequestorKey,
  CaseType,
  BatchDocumentProcess,
  NotificationType,
  ConfirmDialogType,
  NotificationAlerts,
  SiteSelectionAlerts,

  CaseDocumentListMapping
};


export default EnumUtility;
 */